<template>
  <template v-if="!loading && canBeRented(price)">
    <x-topi-cart-rental-summary-label
      ref="topi"
      class="topi"
      mode="product"
      :reference="productId"
    />
  </template>
</template>

<script setup lang="ts">
import { SimplePrice } from '@/generatedTypes'
import { canBeRented } from '@/modules/product/helpers'
import { PropType } from 'vue'

defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  price: {
    type: Object as PropType<SimplePrice>,
    default: undefined
  },
  productId: {
    type: Number,
    required: true
  }
})
</script>

<style lang="scss">
.topi > div {
  justify-content: flex-end;
}
</style>
